import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[clSettingsHost]'
})
export class SettingsHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
